/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { PageState, PageActionTypes } from './types';
import merge from 'lodash.merge';
import mergeWith from 'lodash.mergewith';

export const initialState: PageState = {
  data: {
    page: {},
  },
  screenId: undefined,
  styleChunks: {
    refs: {
    },
    indexes: {},
  },
  session_data: {},
  settings: {},
  variableData: {},
  formValues: {},
  loading: true,
};

const reducer: Reducer<PageState> = (state = initialState, action) => {
  switch (action.type) {
    case PageActionTypes.PAGE_REQUEST: {
      return { ...state, loading: true, notifications: [] };
    }
    case PageActionTypes.SET_FORM_VALUES_SUCCESS: {
      return { ...state, formValues: { ...state.formValues,  ...action.payload.data } };
    }
    case PageActionTypes.RESET_FORM_VALUES_SUCCESS: {
      return { ...state, formValues: { ...action.payload.data } };
    }
    case PageActionTypes.ACTIVATE_LOCAL_SHIMMER_SUCCESS: {
      return {
        ...state, 
        session_data: {
          ...state.session_data,
          localShimmer: true
        }
      }
    }
    case PageActionTypes.PAGE_SUCCESS: {
      return {
        ...state,
        loading: false,
        previewFile: undefined,
        screenId: action.payload.screenId,
        data: {
          page: action.payload.data,
        },
        settings: action.payload.settings ? { ...action.payload.settings } : state.settings,
        variableData: { ...action.payload.variableData },
        session_data: { ...action.payload.session_data },
      };
    }
    case PageActionTypes.MERGE_STYLE_SUCCESS: {
      return {
        ...state,
        data: {
          page: action.payload.data,
        },
      };
    }
    case PageActionTypes.UNCHECK_DEPENDENT_RADIO_SUCCESS: { 
      return {
        ...state,
        data: {
          page: action.payload.data,
        },
      };
    }
    case PageActionTypes.UPDATE_VARIABLE_SUCCESS: {
      // replaceArrays: $setVariable writes replace arrays wholesale ([x] over [a,b,c] → [x]).
      // Default (Variables-chunk path) keeps lodash index-merge — sparse partial arrays
      // like products[2].edit_icon_state depend on it.
      const { data, replaceArrays } = action.payload;
      return {
        ...state,
        variableData: replaceArrays
          ? mergeWith({}, state.variableData, data, (_dst, src) => (Array.isArray(src) ? src : undefined))
          : merge({}, state.variableData, data),
      };
    }
    case PageActionTypes.CLEAR_FORMS: {
      return { ...state, data: { ...state.data, forms: [] } };
    }
    default: {
      return state;
    }
  }
};

export { reducer as pageReducer };
